import { render, staticRenderFns } from "./ChatChat.vue?vue&type=template&id=59f7b454&"
import script from "./ChatChat.vue?vue&type=script&lang=js&"
export * from "./ChatChat.vue?vue&type=script&lang=js&"
import style0 from "./ChatChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports